'use strict';

module.exports = [
  '$stateProvider',
  function ($stateProvider) {
    /** Configuro gli endpoint **/

    $stateProvider.state('situation-record-index', {
      url: '/situation-record',
      template: require('./components/index/index.html'),
      controller: 'srIndexCtrl',
      parent: 'main',
    });
    $stateProvider.state('situation-record-new', {
      url: '/situation-record/new',
      template: require('./components/situationRecord/situationRecordMgmt.html'),
      controller: 'situationRecordMgmtCtrl',
      parent: 'main',
      params: {
        situationRecordType: null,
        situationRecordFromTemplate: null,
        curSearchTemplateFilter: null,
        clonedSituationRecord: null,
        curSearchFilter: null,
      },
    });
    $stateProvider.state('situation-record-mgmt', {
      url: '/situation-record/mgmt/:id',
      template: require('./components/situationRecord/situationRecordMgmt.html'),
      controller: 'situationRecordMgmtCtrl',
      parent: 'main',
      params: {
        curSearchFilter: null,
        curSearchTemplateFilter: null,
        template: null,
      },
    });
    $stateProvider.state('situation-record-template-mgmt', {
      url: '/situation-record/template',
      template: require('./components/situationRecord/situationRecordMgmt.html'),
      controller: 'situationRecordMgmtCtrl',
      parent: 'main',
      params: {
        template: null,
        curSearchTemplateFilter: null,
      },
    });
    $stateProvider.state('situation-record-search', {
      url: '/situation-record/search',
      template: require('./components/situationRecord/situationRecordSearch.html'),
      controller: 'situationRecordSearchCtrl',
      parent: 'main',
      params: {
        curSearchFilter: null,
      },
    });
    $stateProvider.state('source-list', {
      url: '/source/source-list',
      template: require('./components/source/sourceList.html'),
      controller: 'sourceListCtrl',
      parent: 'main',
    });
    $stateProvider.state('situation-record-template-search', {
      url: '/templates/situation-record-template-search',
      template: require('./components/situationRecordTemplate/situationRecordTemplateSearch.html'),
      controller: 'situationRecordTemplateSearchCtrl',
      parent: 'main',
      params: {
        curSearchTemplateFilter: null,
      },
    });

    $stateProvider.state('situation-record-keyword-list', {
      url: '/keywords',
      template: require('./components/keyword/keywordList/keywordList.html'),
      controller: 'keywordsListCtrl',
      parent: 'main',
    });
    $stateProvider.state('situation-record-keyword-add', {
      url: '/keywords/add',
      template: require('./components/keyword/keywordDetail/keywordDetail.html'),
      controller: 'keywordsDetailCtrl',
      parent: 'main',
    });
    $stateProvider.state('situation-record-keyword-edit', {
      url: '/keywords/:id/edit',
      template: require('./components/keyword/keywordDetail/keywordDetail.html'),
      controller: 'keywordsDetailCtrl',
      parent: 'main',
    });

    $stateProvider.state('situation-record-channel-list', {
      url: '/channels',
      template: require('./components/channel/channelList/channelList.html'),
      controller: 'channelsListCtrl',
      parent: 'main',
    });
    $stateProvider.state('situation-record-channel-add', {
      url: '/channels/add',
      template: require('./components/channel/channelDetail/channelDetail.html'),
      controller: 'channelsDetailCtrl',
      parent: 'main',
    });
    $stateProvider.state('situation-record-channel-edit', {
      url: '/channels/:id/edit',
      template: require('./components/channel/channelDetail/channelDetail.html'),
      controller: 'channelsDetailCtrl',
      parent: 'main',
    });

    $stateProvider.state('public-carousel', {
      url: '/public-carousel',
      template: require('./components/publicCarousel/publicCarousel.html'),
      controller: 'publicCarouselCtrl',
      parent: 'main',
    });

    $stateProvider.state('news-bullettin', {
      url: '/news-bullettin',
      template: require('./components/newsBullettin/newsBullettin.html'),
      controller: 'newsBullettinCtrl',
      parent: 'main',
    });
  },
];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/module-states.js
// module id = 283
// module chunks = 0